<template>
  <b-container fluid class="page-account">
    <b-row>
      <b-col class="header-nav-bar">
        <HeaderNavBar active-link="my_account_details" />
      </b-col>
    </b-row>
    <b-row class="body-padding">
      <b-col md="12" class="menu-left">
        <MenuLeft
          v-on:navigate="navigate($event)"
          :customerInfo="customerInfo"
        />
      </b-col>

      <b-col class="content">
        <b-container style="margin-right: 0rem; margin-left: 0rem; ">
          <b-row>
            <component
              :is="contentComponent"
              @updated="contentUpdated"
              :customerInfo="customerInfo"
            />
          </b-row>
        </b-container>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import HeaderNavBar from "@/components/private/my-account/HeaderNavBar.vue";
import Billing from "@/components/private/my-account/Billing.vue";
import Invoices from "@/components/private/my-account/Invoices.vue";
import Subscriptions from "@/components/private/my-account/Subscriptions.vue";
import MenuLeft from "@/components/private/my-account/MenuLeft.vue";

export default {
  title: "Dropsmart - My Account",
  name: "MyAccount",
  props: ["page"],
  mounted() {
    this.customerInfo = JSON.parse(sessionStorage.getItem("customerInfo"));
    let target = this.page ? this.page : "Invoices";
    console.log("navigating to " + target);
    this.navigate(target);
  },
  data() {
    return {
      content: null,
      customerInfo: null,
    };
  },
  computed: {
    contentComponent() {
      return this.content;
    },
  },
  components: {
    HeaderNavBar,
    MenuLeft,
    Billing,
    Invoices,
    Subscriptions,
  },
  methods: {
    navigate(routeName) {
      this.content = routeName;
    },
    contentUpdated() {
      this.customerInfo = JSON.parse(sessionStorage.getItem("customerInfo"));
    },
  },
};
</script>
<style lang="scss">
$color: #000000;

html,
body {
  height: 100%;
  margin: 0 1rem;
}

//hidden scrollbar Firefox
html {
  scrollbar-width: none;
}

//hidden scrollbar Chrome, Safari and Opera
body::-webkit-scrollbar {
  display: none;
}

.page-account {
  .header-nav-bar {
    padding-right: 0;
    padding-left: 0;
  }
  .body-padding {
    padding-top: 70px;
  }
  .menu-left {
    background-color: #ffffff;
    padding-bottom: 65px;
  }
  .content {
    background-color: #ffffff;
  }
}

.my-account {
  color: $color;
  margin-bottom: 30px;
  a {
    color: #509610;
    &:hover {
      color: $color;
    }
  }
}
@media screen and (max-width: 768px) {
}
@media screen and (min-width: 768px) {
  .container,
  .container-fluid {
    .menu-left {
      max-width: 390px;
    }
  }
}

@media screen and (max-width: 600px) {
  .page-account {
    .body-padding {
      padding-top: 200px;
    }
  }
}
</style>
